import { createSelector } from '@reduxjs/toolkit'
import { getChannels } from 'src/model/selectors/base'
import _ from 'lodash'

export const getChannelsByLesson = createSelector([getChannels], channels => {
  return _.groupBy(channels, 'lessonId')
})
